export enum APValidationLivenessAssessmentTypes {
    Live = 'Live',
    NotLive = 'NotLive',
    Error = 'Error',
    PoorQuality = 'PoorQuality',
}
